<template>
  <v-app :class="{'roboto' : $store.state.lang == 'en' || $store.state.lang == 'id', 'notoSC': $store.state.lang == 'cn' || $store.state.lang == 'tw', 'arial' : $store.state.lang == 'pt', 'OA' : $store.state.lang == 'kr'}">
      <v-main class="mainBg">
          <Header />

          <div class="transBody">
              <router-view />
          </div>

          <Footer />
      </v-main>
  </v-app>
</template>

<script>

    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'

    export default {
        name: 'App',
        components: {
            Header,
            Footer,
        },
        computed: {
            responseRouter() {
                return this.$route.path
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/assets/styles/variables.scss';

    @font-face {
        font-family: 'OAGothic';
        src: url('assets/fonts/OAGothic-Medium.otf') format('opentype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'OAGothic';
        src: url('assets/fonts/OAGothic-ExtraBold.otf') format('opentype');
        font-weight: bold;
        font-style: normal;
    }

    #app {
        min-width: 320px;

        .OA {
            .v-application__wrap {
                font-family: 'OAGothic' !important;
                font-weight: 400;
            }
        }

        .roboto {
            .v-application__wrap {
                font-family: "Roboto", sans-serif !important;
                font-weight: 400;
            }
        }

        .notoSC {
            .v-application__wrap {
                font-family: "Noto Sans SC", sans-serif !important;
                font-weight: 400;
            }
        }

        .arial {
            .v-application__wrap {
                font-family: 'Arial' !important;
                font-weight: 400;
            }
        }
    }

    .transBody {
        min-height: 100vh;
        .transferTxtBox {
            .title {
                text-align: center;
                font-size: 26px;
                font-weight: 500;
                font-weight: bold;
                /*text-shadow: #000 1px 0 8px;*/
                span {
                    color: #3F51B5;
                }
            }

            .listTxt {

                .listSubTxt {
                    text-align: center;
                    font-size: 20px;
                    font-weight: 500;
                }

                .subtitle {
                    margin-top: 10px;
                    text-align: left;
                    font-weight: bold !important;
                }
            }
        }

        .btnBox {
        }
    }
    .tts {
        margin-bottom: 10px;
        color: #eee;
        text-align: left;
    }

    .mainBg {
        background: #2b0102;
        min-height: 1000px;
    }

    @media all and (max-width: 640px) {
        .mainBg {
            min-height: 100vh;
        }
    }
</style>